import { HoveredContainer } from './HoveredButtons.styles';

/**
 * Placed in the parent components styling
 * @returns {String}
 */
export const handleHoveredButtonCSS = () => `&:hover ${HoveredContainer} {
    display: flex;
  }`;

/**
 * Ensure the timeout is identical if want to use for styling in a parent component
 * @param {Function} setIsCopied
 */
export const handleSetIsCopiedTimer = setIsCopied => {
  setIsCopied(true);

  setTimeout(() => {
    setIsCopied(false);
  }, 3000);
};
